module.exports = __webpack_public_path__ + "img/td-synnex-logo.eede5711.png";